module.exports = __webpack_public_path__ + "img/onboarding1.7da87ec2.png";